(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('PasswordUpdateByLogin', PasswordUpdateByLogin);

    PasswordUpdateByLogin.$inject = ['$resource'];

    function PasswordUpdateByLogin($resource) {

        var service = {
            changeUserPassword: changeUserPassword
        };
        return service;

        function changeUserPassword(login, password, callback) {
            var cb = callback || angular.noop;
            $resource('api/account/change_user_password', {}, {})
                .save(
                    {login: login, password: password},
                    function() {
                        return cb();
                    }, function(err){
                        return cb(err);
                })
                .$promise;
        }
    }

})();
